import { Injectable, isDevMode } from '@angular/core';
import { HttpRequestUrl } from '../models/http.request.models/request.url';

@Injectable({
  providedIn: 'root',
})
export class ApiAddressService {
  private baseUrlTest: string = 'https://sandboxapiv4.quotemonster.co.nz/api/';
  //private baseUrlTest: string = 'http://localhost:4889/api/';
  private baseUrlLive: string = 'https://apiv2.quotemonster.co.nz/api/';
  private version: string = '';

  getBaseUrl(): string {
    if (isDevMode()) {
      return this.baseUrlTest;
    } else {
      return this.baseUrlLive;
    }
  }

  getOldSiteUrl(): string {
    if (isDevMode()) {
      return 'https://qa.quotemonster.co.nz/old/';
    } else {
      return 'https://secure.quotemonster.co.nz/ssl/default.aspx';
    }
  }

  getBlogUrl() {
    return 'https://blog.quotemonster.co.nz/wp-json/wp/v2/posts';
  }

  getTrackingApiErrorUrl() {
    return this.getBaseUrl() + this.version + 'Tracking/ApiError';
  }

  getQMTrackingUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'Tracking', 'PUT');
  }

  getQprAndQeVersionUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'PublicData', 'GET');
  }

  getInfoPageUrl(pageCode: string): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'PublicData/InfoPage?key=' + pageCode, 'GET');
  }

  getQmadsUrl(position: number) {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'PublicData/QmAds?position=' + position, 'GET');
  }

  getCheckFspDetailUrl(fsp: string) {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'PublicData/CheckFsp?fsp=' + fsp, 'GET');
  }

  getCheckEmailUrl(email: string) {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'PublicData/CheckEmail?email=' + email, 'GET');
  }

  getRequiredJsonUrl() {
    return '/assets/requiredData.json';
  }

  /** IGAM Authorize */
  getAccessTokenUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/GetAccess', 'POST');
  }

  getRefreshAccessTokenUrl() {
    return this.getBaseUrl() + this.version + 'IGAM/Authorize/RefreshAccess';
  }

  getRefreshAccessTokenHttpRequestUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/RefreshAccess', 'POST');
  }

  // get user available MFA methods
  getAvailableMfaMethodsUrl(userId: number, deviceCode: string): HttpRequestUrl {
    return new HttpRequestUrl(
      this.getBaseUrl() + this.version + 'IGAM/Authorize/MFAs?userId=' + userId + '&deviceCode=' + deviceCode,
      'GET'
    );
  }

  // add user MFA method
  addMfaMethodUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/MFA', 'POST');
  }

  resendMfaVerificationCodeUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/MFA/ResendVCode', 'POST');
  }

  getRequestReSetPasswordLinkUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/ReSetPassword', 'POST');
  }

  getReSetPasswordByKeyUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/UpdatePasswordByKey', 'POST');
  }

  // resend device verification code
  getReSendUserDeviceVerificationCodeUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/DeviceVerificationCode/ReSend', 'POST');
  }
  // check user device verification code
  checkUserDeviceVerificationCodeUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/DeviceVerificationCode/Check', 'POST');
  }

  // check user MFA verification code
  checkMFAVerificationCodeUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/Authorize/MFA/Check', 'POST');
  }

  /** IGAM Group Members */
  // get available groups
  getAvailableGroupsUrl(): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/AvailableGroups', 'GET');
  }

  // get user available MFA methods
  getGroupMembersUrl(groupId: number): HttpRequestUrl {
    return new HttpRequestUrl(this.getBaseUrl() + this.version + 'IGAM/GroupMembers?groupId=' + groupId, 'GET');
  }
}
